import React from "react";
import ModalSafeArea from "./ModalSafeArea";
import { FormSatisfaction } from "views/Satisfaction";
import { toast } from "react-toastify";

const FeedbackActionModal = ({ open, onClose, backdropOpacity = 0.35, style }) => {
    return (
        <ModalSafeArea open={open} onClose={onClose} backdropOpacity={backdropOpacity} style={style}>
            <div className="relative bg-white rounded-md shadow-2xl p-6 ">
                <button
                    aria-label="Close"
                    style={{ right: "1rem" }}
                    className="absolute  top-2 text-2xl text-gray-900"
                    onClick={onClose}
                >
                    <i className="icon icon-close"></i>
                </button>
                <FormSatisfaction
                    variant="modal"
                    onCompleted={onClose}
                    onError={(error) => {
                        if (error?.message) {
                            toast.error(error.message);
                        }
                        onClose();
                    }}
                />
            </div>
        </ModalSafeArea>
    );
};

export default FeedbackActionModal;
